import React, {
  useCallback,
  useEffect, useState,
} from 'react';
import { T2 } from '../../../styles/titles';
import LoadingOverlay from '../../../components/LoadingOverlay';
import { Container } from './styles';
import LiveTable from "./liveTable";
import LinkDeAssinaturaService from "../service/linkDeAssinaturaService";

const ListarAssinaturas: React.FC = () => {
  const linkDeAssinaturaService = new LinkDeAssinaturaService();
  const selectedBusiness = localStorage.getItem('selectedCompany') ? JSON.parse(localStorage.getItem('selectedCompany') as string) :null;
  const user = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') as string) :null;
  const [assinaturas, setAssinaturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getLinksDePagamento()
  }, []);

  const getLinksDePagamento = async () => {
    try {
      setIsLoading(true);
      const response = await linkDeAssinaturaService.getAllLinks(selectedBusiness, user);
      setAssinaturas(response);
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  }



  return (
    <Container>
      <LoadingOverlay
        show={isLoading}
        relative
      />
      <T2>Assinaturas</T2>
      <LiveTable setLink={setAssinaturas} dataFilter={assinaturas}  />
    </Container>
  );
}
export default ListarAssinaturas;
